import { Injectable } from '@angular/core';
import {
    AccountMappingTemplateGroupItem,
    IAccountMappingTemplate,
    IAccountMappingTemplateGroup,
    IAccountMappingTemplateGroupItemFLI,
    ItemType,
} from '@modeso/types__aumico-lib-annualreport-be';
import { FinancialLineItemType } from '@modeso/types__aumico-lib-settings-be';
import { flatten } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class FlisTypesHelper {
    public getFliIdToTypeForTemplates(
        balanceTemplate: IAccountMappingTemplate,
        incomeTemplate: IAccountMappingTemplate,
    ): Map<string, FinancialLineItemType> {
        const balanceFlisToType = this.getFlisTypesOfTemplate(balanceTemplate);
        const incomeFlisToType = this.getFlisTypesOfTemplate(incomeTemplate);

        return this.mergeArrayOfMaps([balanceFlisToType, incomeFlisToType]);
    }

    private getFlisTypesOfTemplate(template: IAccountMappingTemplate): Map<string, FinancialLineItemType> {
        if (template == null) {
            return new Map<string, FinancialLineItemType>();
        }
        const templateGroups = [template.group];

        return this.getFlisTypesOfGroups(templateGroups);
    }

    private getFlisTypesOfGroups(templateGroups: IAccountMappingTemplateGroup[]): Map<string, FinancialLineItemType> {
        const fliIdsToTypes: Map<string, FinancialLineItemType>[] = [];

        for (const group of templateGroups) {
            const fliIdToTypeOfGroup = this.extractFlisTypesOfGroup(group.items);
            fliIdsToTypes.push(fliIdToTypeOfGroup);

            if (group.groups != null && group.groups.length > 0) {
                const flidToTypeOfInnerGroups = this.getFlisTypesOfGroups(group.groups);
                fliIdsToTypes.push(flidToTypeOfInnerGroups);
            }
        }

        return this.mergeArrayOfMaps(fliIdsToTypes);
    }

    private extractFlisTypesOfGroup(
        itemsOfGroup: AccountMappingTemplateGroupItem[],
    ): Map<string, FinancialLineItemType> {
        const fliIdToType = new Map<string, FinancialLineItemType>();
        for (const item of itemsOfGroup) {
            if (item.type !== ItemType.SUB_TOTAL) {
                const fli = item as IAccountMappingTemplateGroupItemFLI;
                fliIdToType.set(fli.name, fli.fliType);
            }
        }
        return fliIdToType;
    }

    private mergeArrayOfMaps(arrayOfMaps: Map<string, FinancialLineItemType>[]): Map<string, FinancialLineItemType> {
        const spreadMaps = arrayOfMaps.map((value) => [...value]);
        const flattenedMaps = flatten<[string, FinancialLineItemType]>(spreadMaps);
        return new Map<string, FinancialLineItemType>(flattenedMaps);
    }
}
